import { render, staticRenderFns } from "./TypeControlDetailNew.vue?vue&type=template&id=3d37505a"
import script from "./TypeControlDetailNew.vue?vue&type=script&lang=js"
export * from "./TypeControlDetailNew.vue?vue&type=script&lang=js"
import style0 from "./TypeControlDetailNew.vue?vue&type=style&index=0&id=3d37505a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports